import FadeInSection from '../../../components/feature/FadeInSection';

export default function GreetingSocialSection() {
  return (
    <section className="section-padding" style={{ background: '#faf7f4' }}>
      <div className="content-width">
        {/* Section Header */}
        <FadeInSection>
          <div className="mb-12">
            <p
              className="inline-block px-4 py-1 rounded-full text-sm font-bold mb-4"
              style={{ background: '#f2f8f4', color: '#5a9e6f' }}
            >
              社会貢献への取り組み
            </p>
            <h2
              style={{
                color: '#4a3728',
                fontSize: 'clamp(22px, 3vw, 30px)',
                fontWeight: '700',
                lineHeight: '1.6',
              }}
            >
              「縁結び和はは」では、シニアの方の<br className="hidden sm:block" />
              幸せな未来を支援する社会貢献を行っています。
            </h2>
          </div>
        </FadeInSection>

        {/* Content Card 1 */}
        <FadeInSection>
          <div
            className="rounded-2xl overflow-hidden"
            style={{ background: '#fff', border: '1px solid #e8d8cc' }}
          >
            <div className="flex flex-col lg:flex-row">
              <div className="w-full lg:w-[420px] shrink-0 h-[280px] lg:h-auto">
                <img
                  src="https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/social1.jpg"
                  alt="スマホ教室・社会とのつながりを増やす取り組み"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-8 lg:p-12">
                <div className="flex items-center gap-3 mb-6">
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
                    style={{ background: '#5a9e6f' }}
                  >
                    <span className="text-white font-bold text-lg">①</span>
                  </div>
                  <h3
                    style={{
                      color: '#4a3728',
                      fontSize: 'clamp(17px, 2vw, 21px)',
                      fontWeight: '700',
                      lineHeight: '1.5',
                    }}
                  >
                    社会とのつながりを増やす取り組み
                  </h3>
                </div>
                <div
                  style={{ color: '#6b5a4e', fontSize: '15px', lineHeight: '2.0' }}
                  className="space-y-4"
                >
                  <p>
                    年齢を重ねる中で、外出の機会や人との関わりが少なくなり、
                    知らないうちに「社会とのつながり」が減ってしまうことがあります。
                  </p>
                  <p>
                    これは、健康の観点でも大きな課題とされており、
                    フレイル予防においても「人と関わること」「社会とつながること」が大切だといわれています。
                  </p>
                  <p>
                    和ははでは、そうした背景をふまえ、
                    <strong style={{ color: '#4a3728', fontWeight: '700' }}>
                      "社会とつながるきっかけづくり"
                    </strong>
                    を大切にしています。
                  </p>
                  <p>
                    その一つとして、日常のコミュニケーションや情報取得の手段となるスマートフォンに着目し、
                    スマホ教室や個別相談を行っています。
                    「使い方がわからない」から一歩進んで、人とつながるためのツールとして活用できるようにサポートしています。
                  </p>
                </div>
                <div className="flex flex-wrap gap-2 mt-7">
                  {['フレイル予防', 'スマホ教室', '個別相談', '社会参加支援'].map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 rounded-full text-xs font-semibold"
                      style={{ background: '#f2f8f4', color: '#5a9e6f' }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </FadeInSection>

        {/* Content Card 2 */}
        <FadeInSection className="mt-8">
          <div
            className="rounded-2xl overflow-hidden"
            style={{ background: '#fff', border: '1px solid #e8d8cc' }}
          >
            <div className="flex flex-col lg:flex-row-reverse">
              <div className="w-full lg:w-[420px] shrink-0 h-[280px] lg:h-auto">
                <img
                  src="https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/greeting-social.jpeg"
                  alt="ご縁をつなぐことで心と健康を支える"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-8 lg:p-12">
                <div className="flex items-center gap-3 mb-6">
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
                    style={{ background: '#5a9e6f' }}
                  >
                    <span className="text-white font-bold text-lg">②</span>
                  </div>
                  <h3
                    style={{
                      color: '#4a3728',
                      fontSize: 'clamp(17px, 2vw, 21px)',
                      fontWeight: '700',
                      lineHeight: '1.5',
                    }}
                  >
                    ご縁をつなぐことで、心と健康を支える
                  </h3>
                </div>
                <div
                  style={{ color: '#6b5a4e', fontSize: '15px', lineHeight: '2.0' }}
                  className="space-y-4"
                >
                  <p>
                    人とのつながりは、心の安心だけでなく、健康にも大きな影響を与えることがわかっています。
                    例えば、孤独や社会的孤立は認知症のリスクを高める要因の一つとされており、
                    反対に、人と関わる機会があることは予防につながるといわれています。
                  </p>
                  <p>
                    また、誰かと会う予定があることで外出の機会が増えたり、
                    身だしなみや生活リズムを整えるきっかけにもなります。
                  </p>
                  <p>
                    和ははでは、単に結婚相手を探すだけではなく、
                    <strong style={{ color: '#4a3728', fontWeight: '700' }}>
                      「誰かとつながること」そのものに価値がある
                    </strong>
                    と考えています。
                  </p>
                  <p>
                    ご縁をつなぐことで、日々の生活に楽しみや安心が生まれ、結果として、心も体も健やかに過ごしていただける——
                    そんな未来につながるサポートを行っています。
                  </p>
                </div>
                <div className="flex flex-wrap gap-2 mt-7">
                  {['認知症予防', '孤独・孤立対策', '心身の健康', '生活リズム'].map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 rounded-full text-xs font-semibold"
                      style={{ background: '#f2f8f4', color: '#5a9e6f' }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </FadeInSection>

        {/* Content Card 3 */}
        <FadeInSection className="mt-8">
          <div
            className="rounded-2xl overflow-hidden"
            style={{ background: '#fff', border: '1px solid #e8d8cc' }}
          >
            <div className="flex flex-col lg:flex-row">
              <div className="w-full lg:w-[420px] shrink-0 h-[280px] lg:h-auto">
                <img
                  src="https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/social3.jpg"
                  alt="地域への貢献・グラウンドゴルフなど地域活動への参加"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-8 lg:p-12">
                <div className="flex items-center gap-3 mb-6">
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
                    style={{ background: '#5a9e6f' }}
                  >
                    <span className="text-white font-bold text-lg">③</span>
                  </div>
                  <h3
                    style={{
                      color: '#4a3728',
                      fontSize: 'clamp(17px, 2vw, 21px)',
                      fontWeight: '700',
                      lineHeight: '1.5',
                    }}
                  >
                    地域への貢献
                  </h3>
                </div>
                <div
                  style={{ color: '#6b5a4e', fontSize: '15px', lineHeight: '2.0' }}
                  className="space-y-4"
                >
                  <p>
                    「人の幸せは、人とのつながりから生まれる」そんな想いのもと、
                    和ははでは地域との関わりを大切にしています。
                  </p>
                  <p>
                    地域で行われている活動やイベントにも積極的に参加し、
                    実際にシニアの方々と同じ時間を過ごしながら、自然なつながりを育んでいます。
                  </p>
                  <p>
                    たとえば、グラウンドゴルフなどの活動にも参加し、
                    日常の中での交流を通して、
                    <strong style={{ color: '#4a3728', fontWeight: '700' }}>
                      気軽に話せる関係づくり
                    </strong>
                    を大切にしています。
                  </p>
                  <p>
                    これからも、地域の中に入りながら、人と人がつながるきっかけを広げていきたいと考えています。
                  </p>
                </div>
                <div className="flex flex-wrap gap-2 mt-7">
                  {['地域活動', 'グラウンドゴルフ', 'コミュニティ', '自然なつながり'].map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 rounded-full text-xs font-semibold"
                      style={{ background: '#f2f8f4', color: '#5a9e6f' }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
